<template>
  <div>
    <div class="header">
      <div class="shortcut-bar">
        <div class="max-w flex">
          <div class="shortcut-user" v-if="!userStore.nickName">
            <router-link to="/login">登录 </router-link>
            /
            <router-link to="/register">注册</router-link>
          </div>
          <div class="shortcut-user-login" v-else>
            您好！{{ userStore.nickName }}
            <span @click="logOut()" class="logOut">退出</span>
          </div>

          <div class="shortcut-navs flex">
            <div class="shortcut-nav">
              <router-link :to="{ path: '/' }">商城首页</router-link>
            </div>

            <div class="shortcut-nav" v-if="!appStores.isShopHost">
              <a :href="domain">数智化集采商城</a>
            </div>
            <!-- 全面放在调整 -->
            <div class="shortcut-nav" v-if="!appStores.isSmallCompanyHost">
              <a :href="domain_in">中小企业商城</a>
            </div>
            <div class="shortcut-nav" v-if="!inPointShop">
              <a :href="domain_point">积分商城</a>
            </div>

            <div class="divider"></div>
            <!-- 消息中心 -->
            <div class="shortcut-nav cursor-pointer" v-if="userStore.nickName">
              <router-link :to="{ path: '/message' }">
                <i class="el-icon-message"></i>
                消息
                <el-badge
                  :value="userStore.unReadMsgNum"
                  :hidden="userStore.unReadMsgNum == 0"
                  :max="99"
                  class="messgae-badge"
                >
                </el-badge
              ></router-link>
            </div>
            <!-- 个人中心 -->
            <div class="shortcut-nav">
              <router-link to="/usercenter/order">个人中心<i class="el-icon-arrow-down"></i></router-link>
              <div class="shortcut-nav-children">
                <div v-for="(item, index) in nav" :key="'shortcut-nav' + index" class="shortcut-nav-children-box">
                  <template v-for="(iitem, iindex) in item.list">
                    <router-link :to="{ name: iitem.name }" :key="'shortcut-nav-children' + iindex"
                      >{{ iitem.title }}
                    </router-link>
                  </template>
                </div>
              </div>
            </div>
            <!-- 采购服务 -->
            <div class="shortcut-nav">
              <router-link to="/buyerService">采购服务<i class="el-icon-arrow-down"></i></router-link>
              <div class="shortcut-nav-children">
                <div class="shortcut-nav-children-box one">
                  <a @click="showDia('小程序-买家版')">小程序-买家版</a>
                 
                  <router-link v-if="appStores.showEntertainment" :to="{ path: appStores.entertainmentFirstRoute }"
                    >销售中心 {{ appStores.entertainmentFirstRoute }}</router-link
                  >
                  <router-link v-else :to="{ path: '/buyerService' }">升级采购服务</router-link>
                </div>
              </div>
            </div>
            <!-- 商家服务 -->
            <div class="shortcut-nav">
              <router-link to="/merchantService">商家服务<i class="el-icon-arrow-down"></i></router-link>

              <div class="shortcut-nav-children">
                <div class="shortcut-nav-children-box one">
                  <router-link v-if="appStores.showShopCenter" :to="{ path: appStores.shopCenterFirstRoute }"
                    >商家中心</router-link
                  >
                  <router-link v-else :to="{ path: '/merchantService' }">商家入驻</router-link>
                  <a @click="showDia('小程序-卖家版')">小程序-卖家版</a>
                </div>
              </div>
            </div>
            <!-- 联系客服 -->
            <div class="shortcut-nav">
              <a href="https://work.weixin.qq.com/kfid/kfc8aaed7d6d8e7f4fb" target="_blank">联系客服</a>
            </div>
            <div class="divider"></div>
            <div class="shortcut-nav phone">
              <a :href="`tel: ${appStores.appSetting.phone}`"
                ><i class="el-icon-phone"></i> {{ appStores.appSetting.showPhone }}</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 常规搜索头部 -->
      <div class="dis-affix-search" v-if="!isHideSearchHeader">
        <div class="max-w">
          <div class="serach flex">
            <div class="logo">
              <router-link to="/"
                ><img
                  :src="
                    appStores.appSetting.headerLogo
                      ? appStores.appSetting.headerLogo
                      : require('@/assets/images/header-logo.svg')
                  "
                  alt="logo"
                />
                <span
                  >智电云商·{{ appStores.isInner ? '中小企业' : '数智化' }}集采商城
                  {{ isHideSearchHeader }}</span
                >
              </router-link>
            </div>

            <div class="right-box">
              <div class="search-box flex">
                <div class="input-warp flex">
                  <el-autocomplete
                    placeholder="请输入商品名称 品牌 型号规格"
                    popper-class="search-autocomplete"
                    v-model="searchKey"
                    @keyup.enter.native="doSearch()"
                    clearable
                    :fetch-suggestions="querySearch"
                    @select="handleSelect"
                    :popper-append-to-body="false"
                  >
                    <template v-slot="{ item }">
                      <div class="search-item flex">
                        <div v-html="keyRed(item.value, searchKey)" class="search-item-name"></div>

                        <div class="icon" v-if="!searchKey">
                          <span class="text">搜索历史</span
                          ><span class="function" @click.stop="appStores.removeHistory(item)">删除记录</span>
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                  <el-button icon="el-icon-search" type="primary" @click="doSearch()">搜索</el-button>
                </div>

                <div class="btn-group">
                  <el-badge
                    :value="productStore.shoppingcartNum"
                    :hidden="productStore.shoppingcartNum == 0"
                    class="item"
                    :max="99"
                  >
                    <router-link :to="{ name: 'shoppingCart' }">
                      <el-button type="primary" @click="hinaAddCart" class="-mt-6px"
                        ><i class="MRO-gouwuche-kong mro"></i>我的购物车</el-button
                      >
                    </router-link>
                  </el-badge>
                  <router-link :to="{ name: 'order-batchCreateOrder' }">
                    <el-button><i class="MRO-dianzipiao mro"></i>批量下单</el-button>
                  </router-link>
                </div>
              </div>
              <div class="hot" v-if="hotKey?.length">
                <span v-for="(item, index) in hotKey" :key="'hotKey' + index" @click="doHot(item)">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="dialog.type" :visible.sync="dialog.show" width="380px" center>
      <img src="@/assets/images/买家版.jpg" v-if="dialog.type == '小程序-买家版'" alt="微信客服" />
      <img src="@/assets/images/卖家版.jpg" v-if="dialog.type == '小程序-卖家版'" alt="微信客服" />
    </el-dialog>
  </div>
</template>
<script lang="ts" setup>
import { checkRole } from '@/utils/permission'; // 权限判断函数
import { userInfo } from '@/stores/userInfo';
import catalogListVue from './catalogList.vue';
import { productInfo } from '@/stores/productInfo';
import { appInfo } from '@/stores/appInfo';
import {
  matchAnswer,
  matchAnswerRestful,
  getactivityZoneList,
  matchSupplierAnswer,
  getNotice,
  getPopularRecommend,
  getINPopularRecommend,
} from '@/api/product';
import { getUnReadCount } from '@/api/message';
import { useRouter } from '../../router/index';
import * as hinaApi from '@/utils/hina';
const domain = import.meta.env.VITE_APP_DOMAIN;
const domain_in = import.meta.env.VITE_APP_DOMAIN_INNER;
const domain_point = import.meta.env.VITE_APP_DOMAIN_POINT;
const { proxy } = getCurrentInstance();
const route = useRoute();
const appStores = appInfo();
const productStore = productInfo();
const userStore = userInfo();
const nav = ref(appStores.topUserRoute);
const searchKey = ref('');
const dialog = ref({
  show: false,
  type: '',
});
const noticList = ref([]); // 消息轮播列表
const currentIndex = ref(0); //当前消息
const interval = ref(3000); // 切换间隔时间（毫秒）

const hotKey = ref([]);
const qucikLink = ref([]);

const inPointShop = location.host == import.meta.env.VITE_APP_DOMAIN_POINT.replace(/^(https?:|)\/\//, '');

// 是否为半导体页面
const isSemiconductorPage = ref(false);
const isHideSearchHeader = computed(() => {
  return proxy.$route.meta?.noShowSearchHeader
})
watch(
  () => proxy.$route.query,
  (newValue, oldValue) => {
    if (newValue.name) {
      searchKey.value = newValue.name;
    } else {
      searchKey.value = '';
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
watch(
  () => proxy.$route.path,
  (newValue, oldValue) => {
    isSemiconductorPage.value = newValue.includes('semiconductor/list');
  },
  {
    deep: true,
    immediate: true,
  }
);

//搜索操作
function doSearch() {
  if (searchKey.value) {
    appStores.addHistory(searchKey.value);
    useRouter().push({
      name: 'product-list',
      query: { name: searchKey.value, shopName: '全部商城' },
    });
  } else {
    modal.ElMessage.warning('请输入关键词');
  }
}
//搜索建议方法
function querySearch(queryString, cb) {
  if (queryString) {
    if (userStore.nickName) {
      matchAnswer({ name: queryString, pointFlag: 0 }).then(res => {
        let arr = [];
        res.data.forEach(item => {
          arr.push({ value: item });
        });
        cb(arr);
      });
    } else {
      matchAnswerRestful({ name: queryString, pointFlag: 0 }).then(res => {
        let arr = [];
        res.data.forEach(item => {
          arr.push({ value: item });
        });
        cb(arr);
      });
    }
  } else {
    cb(appStores.searchHistory);
  }
}
//点击搜索建议
function handleSelect(item) {
  doSearch();
}
//点击热词
function doHot(item) {
  useRouter().push({
    name: 'product-list',
    query: { shopName: appStores.shopName, productCategoryId: item.id, categoryLevel: 3, noClean: true },
  });
}
//点击退出登录
function logOut() {
  modal.ElMessageBox.confirm('确认退出登录吗', '提示', {
    type: 'warning',
  }).then(() => {
    userStore.LogOut().then(() => {
      appStores.changeInner();
    });
  });
}
//搜索记录标红
function keyRed(str, key) {
  // 将key中的每个字符都转义，以防它们包含正则表达式中的特殊字符
  let escapedKey = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

  // 构建正则表达式模式
  let reg = new RegExp(`(${escapedKey.split('').join('|')})`, 'gi');
  let replace = '<span class="redKey">$1</span>';

  return str.replace(reg, replace);
}
//加载数据
function init() {
  //如果登录获取未读以及购物车数
  if (userStore.isLogin) {
    productStore.getCartNum();
    getUnReadCount(appStores.isInner).then(res => {
      userStore.setunReadMsgNum(res.data.total);
    });
  }
  //获取活动专区数据
  // 登录查找积分专区
  // activityZoneList();
  //获取公告
  loadNotic();
  //获取热门推荐
  loadPopular();
}
function loadNotic() {
  getNotice().then(res => {
    noticList.value = res.rows;
    setInterval(() => {
      nextItem();
    }, interval.value);
  });
}
function nextItem() {
  currentIndex.value = (currentIndex.value + 1) % noticList.value.length;
}

//获取活动专区列表
// function activityZoneList() {
//   getactivityZoneList().then(res => {
//     res.rows.forEach(item => {
//       qucikLink.value.push({ value: item.name, url: `/activityZone/${item.id}` });
//     });
//   });
// }
// 查询热门推荐
function loadPopular() {
  if (userStore.token && appStores.isSmallCompanyHost) {
    getINPopularRecommend({ hostId: userStore.defaultHostId }).then(res => {
      hotKey.value = res.data;
    });
  } else {
    getPopularRecommend({ hostId: appStores.isSmallCompanyHost ? userStore.defaultHostId : 1 }).then(res => {
      hotKey.value = res.data;
    });
  }
}
init();
function showDia(type) {
  dialog.value.show = true;
  dialog.value.type = type;
}

// 加入购物车埋点
function hinaAddCart() {
  hinaApi.headerCartClickPoint({
    inlet: 1,
  });
}
</script>

<style scoped lang="scss">
:deep(.messgae-badge) {
  line-height: 12px;

  .el-badge__content {
    padding: 0 4px;
    line-height: 12px;
    height: 12px;
    border-radius: 16px;
  }
}

.header {
  background: #0c2032;
  color: #fff;

  font-size: 12px;

  .shortcut-bar {
    background: #2e3747;

    .shortcut-user {
      a {
        color: #fff;
        display: inline-block;
      }
    }

    .shortcut-user-login {
      .logOut {
        cursor: pointer;
        margin-left: 8px;

        &:hover {
          color: $main-color;
        }
      }
    }

    .text-carousel {
      flex-grow: 1;
      margin: 0 72px;
      justify-content: flex-start;
      height: 40px;
      overflow: hidden;
      color: $main-color;

      img {
        width: 18px;
      }

      .text > div {
        margin-left: 10px;
        // transform: translateY(0);
        // opacity: 1;
      }

      .slide-fade-enter-active,
      .slide-fade-leave-active {
        transition: all 0.5s;
      }

      .slide-fade-enter {
        transform: translateY(10px);
        opacity: 0;
      }

      .slide-fade-leave-to {
        transform: translateY(-10px);
        opacity: 0;
      }
    }

    .shortcut-navs {
      .divider {
        width: 1px;
        height: 12px;
        background: #fff;
        opacity: 0.4;
        margin: 0 8px;
        box-sizing: border-box;
      }

      .shortcut-nav {
        padding: 0 8px;
        line-height: 40px;
        position: relative;

        box-sizing: border-box;

        span {
          cursor: pointer;
        }

        .el-icon-arrow-down {
          margin-left: 2px;
          transition: transform 0.3s;
        }

        &:last-child {
          padding-right: 0;
          border: none;

          &:hover {
            background: none;
          }
        }

        a {
          display: block;
          color: #fff;
          cursor: pointer;
        }

        .shortcut-nav-children {
          background: #fff;
          display: none;
          position: absolute;
          width: auto;
          z-index: 9999;
          border-radius: 0 0 6px 6px;
          left: 0;
          padding: 0 12px;

          .shortcut-nav-children-box {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 32px;
            border-bottom: 1px solid #e4e7ed;

            &:last-child {
              border: none;
            }

            a {
              font-size: 12px;
              color: #606266;
              line-height: 2.5em;
              white-space: nowrap;
            }
          }

          .shortcut-nav-children-box.one {
            display: block;
          }
        }

        &:hover {
          background-color: #fff;

          a {
            color: $main-color;
          }

          .el-icon-arrow-down {
            transform: rotate(180deg);
          }

          &::before {
            display: none;
          }

          .shortcut-nav-children {
            display: block;
          }
        }
      }

      .info {
        cursor: pointer;

        .el-icon-connection {
          margin-right: 2px;
        }

        .shortcut-nav-children {
          width: auto;
        }
      }

      .phone {
        a {
          .el-icon-mobile-phone {
            margin-right: 2px;
          }

          font-weight: bold;
          color: $main-color;
        }
      }
    }
  }

  .logo {
    width: 200px;
    text-align: justify;
    text-align-last: justify;

    a {
      display: block;
    }

    img,
    span {
      display: block;
    }

    span {
      font-size: 12px;
      color: #ffffff;
      margin-top: 6px;
    }
  }

  .serach {
    padding: 30px 0;

    .right-box {
      margin-left: 50px;
      flex-grow: 1;

      .search-box {
        .input-warp {
          width: 100%;

          ::v-deep .el-select {
            position: relative;

            &::after {
              content: '';
              position: absolute;
              width: 1px;
              height: 16px;
              background: #e4e7ed;
              right: 0;
              top: 12px;
            }

            .el-input__inner {
              border: none;
              border-radius: 6px 0 0 6px;
            }
          }

          ::v-deep .el-autocomplete {
            width: 100%;

            .el-input {
              input {
                border: none;
                border-radius: 6px 0 0 6px;
                // border-right: none;
              }
            }

            .search-autocomplete {
              margin: 2px !important;

              .popper__arrow {
                display: none;
              }

              .search-item {
                width: 100%;

                .redKey {
                  color: $main-color;
                  font-weight: bold;
                }

                .search-item-name {
                  width: 100%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                .icon {
                  font-size: 12px;
                  flex-shrink: 0;
                  margin-left: 8px;
                  user-select: none;

                  .text {
                    color: $main-text-color2;
                  }

                  .function {
                    color: $main-color;
                    display: none;
                  }

                  &:hover {
                    .text {
                      display: none;
                    }

                    .function {
                      display: block;
                    }
                  }
                }
              }
            }
          }

          .el-button {
            border-radius: 0 6px 6px 0;
            padding: 12px 35px;
          }
        }

        .btn-group {
          flex-shrink: 0;

          .el-button {
            margin-left: 20px;

            i {
              margin-right: 6px;
            }
          }
        }
      }

      .hot {
        margin-top: 12px;
        color: #c0c4cc;

        span {
          transform: all 0.3s;
          padding: 0 4px;

          &:first-child {
            padding-left: 0;
          }

          &:hover {
            cursor: pointer;
            color: $main-color;
          }
        }
      }
    }
  }

  .point {
    .point-title {
      font-size: 30px;
      font-weight: bold;
      color: $main-color;
      left: 124px;
      position: relative;
    }
  }

  .nav {
    line-height: 36px;
    font-size: 16px;
    justify-content: flex-start;

    i {
      margin-right: 4px;
    }

    .big-nav {
      width: 300px;
      display: flex;
      justify-content: center;
      position: relative;
      background: $main-color;

      .nav-title {
        color: #fff;
        cursor: pointer;
        flex-grow: 1;
        text-align: center;
        position: relative;

        &::before {
          content: '';
          width: 100%;
          height: 100%;
          background: #000;
          position: absolute;
          left: 0;
          opacity: 0.1;
        }
      }

      .check {
        &::before {
          opacity: 0;
        }
      }

      .catalogList {
        display: none;
        position: absolute;
        top: 36px;
      }

      &:hover {
        .catalogList {
          display: block;
        }
      }
    }

    .quick-link {
      margin: 0 40px;

      a,
      span {
        cursor: pointer;

        i {
          color: $main-color;
        }

        &:hover {
          color: $main-color;
        }
      }

      // .router-link-exact-active {
      //   color: $main-color;
      // }
    }

    .quick-link-active {
      a,
      span {
        color: $main-color;
      }
    }
  }

  .dis-affix-search {
    transition: all 0.5s;
    top: -56px;
  }
  .saleBg {
    background: center no-repeat;
    background-size: cover;
  }

  .affix-search {
    position: fixed;
    width: 100%;
    background: #fff;
    top: 0;
    z-index: 10;
    box-shadow: 0 2px 6px 0 $main-shadow-color;

    .logo {
      width: 120px;
    }

    .nav {
      display: none;
    }

    .serach {
      padding: 10px 0;

      .right-box {
        .search-box {
          width: 60%;
          margin: 0 auto;

          ::v-deep .el-autocomplete .el-input-group__append {
            font-size: 14px;
          }

          .btn-group {
            display: none;
          }
        }

        .hot {
          display: none;
        }
      }
    }
  }
}
</style>
